import React from 'react';
import { Button, Grid } from 'semantic-ui-react';

class MealCounterFooter extends React.Component {
  render() {
    const { checkout, disabled } = this.props;

    return (
      <Grid.Column width={4} className="text-end strong">
        <Button primary disabled={disabled} onClick={checkout}>
          Checkout
        </Button>
      </Grid.Column>
    );
  }
}

export default MealCounterFooter;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/MealCounterFooter.js